<template>
  <div>
    <FileListInput v-model="file_list"/>
    <div class="btns">
        <el-button :disabled="loading" @click="$emit('close')">取消</el-button>
        <el-button :loading="loading" type="primary" @click="handlesSubmit('ruleForm')">添加</el-button>
    </div>
  </div>
</template>

<script>
import FileListInput from '../components/fileListInput.vue'
export default {
    name: 'AddFileSeparateQueueeDialog',
    props: [ 'cbs' ],
    components: {
        FileListInput
    },
    data() {
        return {
            loading: false,
            file_list: []
        }
    },
    methods: {
        handlesSubmit() {
            const file_list = this.file_list.filter(v=> {
                return !!v.trim()
            });
            if (!file_list.length) {
                this.$message.error('文件列表不能为空')
                return
            };
            this.loading = true;
            this.cbs.onSubmit({ 
                file_list
            }, (list)=> {
                this.loading = false
                if (list) {
                    this.file_list = list;
                    this.handlesSubmit()
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>

.btns {
    text-align: center;
    margin-top: 12px;
}

</style>